import { useTranslate } from '@dreryk/react-common';

import { AdditionalRequirementType, formatAdditionalRequirements } from '~libs.shared.prescription';

import { prescriptionTranslationKeys } from '../../../../../translations';
import { StyledPrescriptionTextView } from '../../prescriptionTextView.styled';

type AdditionalRequirementsTextViewProps = {
   readonly additionalRequirementTypes: AdditionalRequirementType[];
};

export const AdditionalRequirementsTextView = (props: AdditionalRequirementsTextViewProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <StyledPrescriptionTextView
         testId={'additionalRequirements'}
         compact
         label={prescriptionTranslationKeys.additionalRequirements.others}
      >
         {formatAdditionalRequirements(props.additionalRequirementTypes, (type) =>
            translate(prescriptionTranslationKeys.additionalRequirements.type[type])
         ) ?? '-'}
      </StyledPrescriptionTextView>
   );
};
